import { Component, EventEmitter, Input, OnInit, Output,OnDestroy } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { CacheKey } from "../../../shared/constants/cachekey.constants";
import { State } from "../../../shared/interface/state.interface";
import { CacheService } from "../../../shared/services/cache.service";
import { CommonService } from "../../../shared/services/common.service";
import { MemberLevel, PurchaseFlow } from "../../common/enumerations";
import { PaymentConstants } from "../../constants/payment.constants";
import { OrderSourceValue } from "../../enums/order-source.enum";
import { PaymentProcessorAlias } from "../../enums/payment-processor-alias.enum";
import { PaymentStatus } from "../../enums/payment-status.enum";
import { PriceTier } from "../../enums/price-tier.enum";
import { ShippingAddressInformation } from "../../interface/address-detail-info";
import { DiscountPercentageResponse } from "../../interface/discount-percentage.response.interface";
import { ECheckAddress } from "../../interface/eCheck/eCheckAddress.interface";
import { NexioPaymentService } from "../../interface/nexiopayment/nexio-payment-service.interface";
import { NexioRegistration } from "../../interface/nexiopayment/nexio-registration.interface";
import { PaymentCallBackUrl } from "../../interface/payvision/payment-callback-url.interface";
import { PaymentComponentSettings } from "../../models/payments/payment.model";
import { CustomerService } from "../../services/customer.service";
import { NexioService } from "../../services/nexio.service";
import { OrderService } from "../../services/order.service";
import { SpinnerService } from "../../services/spinner.service";



@Component({
    selector: 'app-nexio',
    templateUrl: '../../templates/template1/views/payments/nexio.component.html',
    styleUrls: []
})

export class NexioPaymentComponent implements OnInit, OnDestroy {
    states: State[] = [];
    @Input() paymentComponentSettings: PaymentComponentSettings;
    @Input() products: any;
    @Output() savedcardSubmit = new EventEmitter<any>();
    priceTierName: string;
    memberDiscountPercentage: any;

    constructor(private _customerService: CustomerService,
        private _cacheService: CacheService,
        private _nexioService: NexioService,
        private _sectionSpinnerService: SpinnerService,
        private _commonService: CommonService,private _orderService: OrderService) {

    }

    ngOnInit(): void {
        this.getNexioMessages();
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.getStates();
       
    }

    getNexioMessages() {
        window.addEventListener('message', this.iFrameEventFallBackLogic, false);

    }
    iFrameEventFallBackLogic = (event) => {

        if (event.data.event === 'error') {
        }
        if (event.data.event === 'processed') {
            this.submitPaymentStatus(event.data.data);
        }
        if (event.data.event === 'loaded') {
            setTimeout(() => {
                this._sectionSpinnerService.stop('NexioSpinner');
            }, 10000);

        }
        if (event.data.event === 'cardSaved') {
            this._sectionSpinnerService.stop('NexioSpinner');
            this.submitPaymentStatus(event.data.data);

        }

    }

    submitPaymentStatus(data: any): void {
        this._nexioService.saveTokenResponse(data,this.paymentComponentSettings.memberId
            ,OrderSourceValue.CUSTOMER,this.paymentComponentSettings.storeId).subscribe((res) => {
             if(res){
                 this.savedcardSubmit.emit(res);
             }
        }, (error) => {

        });
    }

    getStates() {
        setTimeout(() => {
            this._sectionSpinnerService.start('NexioSpinner');
        }, 0);

        this._customerService.getStates().subscribe(response => {
            if (response) {
                this.states = response;
                this.getNexioPaymentForm();
                }
             else {
                this.getNexioPaymentForm();
            }
        }, (error: any) => {
            this.getNexioPaymentForm();
        });
    }

    getNexioPaymentForm(): void {
        this._nexioService
            .getPaymentForm(this.paymentComponentSettings.storeId, this.getNexioRegistrationRequest())
            .subscribe((response) => {
                this.loadNexioForm(response);
            });
    }

    loadNexioForm(registrationResponse): void {
        this._cacheService.set(CacheKey.IsRefreshed, true);
        if (registrationResponse && registrationResponse.formUrl) {
            window.document.getElementById('nexioIframe').setAttribute('src',registrationResponse.formUrl);
            setTimeout(() => {
                this._sectionSpinnerService.stop('NexioSpinner');
            }, 1000);
        }
    }

    getNexioRegistrationRequest(): NexioRegistration {
        if (this.products && this.products.length) {
            this.memberDiscountPercentage = this.products[0].storePriceTierPercentage  ? this.products[0].storePriceTierPercentage :0;
        }
        if (this.products  && this.products.length) {
            const priceTierId: any = PriceTier[this.products[0].priceTierName];
            const enableWHLSAL00ForAsstSupervisor = this._commonService.isWHLSAL00enabledForAsstSupervisor(this.paymentComponentSettings.isoCountryCode);
            if(priceTierId){
                this.priceTierName = this._commonService.getDiscountPriceLevel(priceTierId, this.memberDiscountPercentage, this.paymentComponentSettings.memberTypeId, enableWHLSAL00ForAsstSupervisor);
            }
        }
        const niRegistration: NexioRegistration = {
            portalCsp: true,
            countryCode: this.paymentComponentSettings.isoCountryCode.toUpperCase(),
            customerId: this.paymentComponentSettings.memberId ? (+this.paymentComponentSettings.memberId) : 0,
            storeId: this.paymentComponentSettings.storeId,
            savedCard: true,
            orderTypeId: this.paymentComponentSettings.orderTypeId ? this.paymentComponentSettings.orderTypeId
                : PurchaseFlow.Personal_Order,
            orderSourceTypeId: OrderSourceValue.CUSTOMER,
            paymentMethodType: this.paymentComponentSettings.paymentMethodTypes.Credit_Card,
            currencyCode: this.paymentComponentSettings.currencyCode,
            checkoutFormCSSURL: this.getCheckoutFormCSSUrl(),
            paymentRequestModel: {
                createRegistartion: true,
            },
            billingAddress: this.getBillingAddress(),
            shippingAddress: this.getShippingAddress(),
            paymentCallBackUrlModel: this.getPaymentCallBackURLModel(),
            paymentServiceModel: this.getPaymentServiceModel(),
            email : this.paymentComponentSettings.memberEmail,
            distrubutorId : this.paymentComponentSettings.distributorId,
            priceTier:this.priceTierName,
        };
        return niRegistration;
    }

    getCheckoutFormCSSUrl() {
        return environment.cdnURL + "/portals/account/template1/css/customstyles.css";
    }
    /**
     * @description this method will return payment call urls
     * @private
     * @returns {PaymentCallBackUrl}
     * @memberof nexioComponent
     */
    private getPaymentCallBackURLModel(): PaymentCallBackUrl {
        const paymentCallBackUrlModel: PaymentCallBackUrl = {
            cancelledUrl: this.getCurrentWindowUrl() + PaymentStatus.CANCELLED.toLowerCase(),
            failureUrl: this.getCurrentWindowUrl() + PaymentStatus.FAILED.toLowerCase(),
            successUrl: this.getCurrentWindowUrl() + PaymentStatus.SUCCESS.toLowerCase(),
            orderSourceTypeId: OrderSourceValue.CUSTOMER,
        };
        return paymentCallBackUrlModel;
    }

    /**
     * @description this method will return network international request model
     * @private
     * @returns {nexioService}
     * @memberof nexioComponent
     */
    private getPaymentServiceModel(): NexioPaymentService {
        const userEmail: string = this.paymentComponentSettings.memberEmail ? this.paymentComponentSettings.memberEmail : '';
        const paymentServiceModel: NexioPaymentService = {
            submit: {
                order: {
                    description: PaymentProcessorAlias.NEXIO,
                    amount: {
                        currencyCode: this.paymentComponentSettings.currencyCode,
                        exponent: this.paymentComponentSettings.numberDecimals
                    },
                    paymentMethodMask: {
                        include: {
                            code: PaymentConstants.paymentMethodMaskCode
                        }
                    },
                    shopper: {
                        shopperEmailAddress: userEmail
                    }
                }
            }
        };
        return paymentServiceModel;
    }

    /**
     * @description this method will return current window url
     * @private
     * @returns {string}
     * @memberof nexioComponent
     */
    private getCurrentWindowUrl(): string {
        const routeURL = window.location.href.includes('posorders') ? '/customerservice/posorders/' : '/customerservice/orders/';
        const currentWindowURL: string = window.location.origin + routeURL
            + PaymentProcessorAlias.NETWORKINTERNATIONAL.toLowerCase() + '/';
        return currentWindowURL;
    }

    /**
    * @description mapping the billing address in the Network International payment form
    * @private
    * @returns {nexio BillingAddress}
    * @memberof nexioComponent
    */
    private getBillingAddress(): ECheckAddress {
        const code = this.paymentComponentSettings.billingAddress && this.paymentComponentSettings.billingAddress.countryCodeTwo
            ? this.paymentComponentSettings.billingAddress.countryCodeTwo : '';
        const billingAddress: ECheckAddress = {
            countryCode: code ? code : (this.paymentComponentSettings.isoTwoletterCountryCode
                ? this.paymentComponentSettings.isoTwoletterCountryCode : ''),
            countryCodeTwo: code ? code : (this.paymentComponentSettings.isoTwoletterCountryCode
                ? this.paymentComponentSettings.isoTwoletterCountryCode : ''),
            country: code ? code : (this.paymentComponentSettings.isoTwoletterCountryCode
                ? this.paymentComponentSettings.isoTwoletterCountryCode : ''),
            city: (this.paymentComponentSettings.billingAddress && this.paymentComponentSettings.billingAddress.city)
                ? this.paymentComponentSettings.billingAddress.city.toString() : '',
            state: (this.paymentComponentSettings.billingAddress && this.paymentComponentSettings.billingAddress.stateId)
                ? this.states.find(x => x.id === this.paymentComponentSettings.billingAddress.stateId).stateCode : '',
            postalCode: (this.paymentComponentSettings.billingAddress && this.paymentComponentSettings.billingAddress.zipCode)
                ? this.paymentComponentSettings.billingAddress.zipCode.toString() : '',
            addressLine1: (this.paymentComponentSettings.billingAddress && this.paymentComponentSettings.billingAddress.addressLine1)
                ? this.paymentComponentSettings.billingAddress.addressLine1.toString() : '',
            addressLine2: (this.paymentComponentSettings.billingAddress && this.paymentComponentSettings.billingAddress.addressLine2)
                ? this.paymentComponentSettings.billingAddress.addressLine2.toString() : '',
            addressLine3: (this.paymentComponentSettings.billingAddress && this.paymentComponentSettings.billingAddress.addressLine3)
                ? this.paymentComponentSettings.billingAddress.addressLine3.toString() : '',
        };
        return billingAddress;
    }

    getShippingAddress() {
        const ShippingAddress: ShippingAddressInformation = {
            firstName: (this.paymentComponentSettings.shippingAddressDetail && this.paymentComponentSettings.shippingAddressDetail.firstName)  ? this.paymentComponentSettings.shippingAddressDetail.firstName : '',
            lastName: (this.paymentComponentSettings.shippingAddressDetail && this.paymentComponentSettings.shippingAddressDetail.lastName) ? this.paymentComponentSettings.shippingAddressDetail.lastName : '',
            addressLine1: (this.paymentComponentSettings.shippingAddressDetail && this.paymentComponentSettings.shippingAddressDetail.addressLine1) ? this.paymentComponentSettings.shippingAddressDetail.addressLine1 : '',
            addressLine2: (this.paymentComponentSettings.shippingAddressDetail && this.paymentComponentSettings.shippingAddressDetail.addressLine2) ? this.paymentComponentSettings.shippingAddressDetail.addressLine2 : '',
            city: (this.paymentComponentSettings.shippingAddressDetail && this.paymentComponentSettings.shippingAddressDetail.city) ? this.paymentComponentSettings.shippingAddressDetail.city : '',
            stateCode: (this.paymentComponentSettings.shippingAddressDetail && this.paymentComponentSettings.shippingAddressDetail.stateCode) ? this.paymentComponentSettings.shippingAddressDetail.stateCode : '',
            countryCode: (this.paymentComponentSettings.shippingAddressDetail && this.paymentComponentSettings.shippingAddressDetail.countryCode) ? this.paymentComponentSettings.shippingAddressDetail.countryCode : '',
            postalCode: (this.paymentComponentSettings.shippingAddressDetail && this.paymentComponentSettings.shippingAddressDetail.postalCode) ? this.paymentComponentSettings.shippingAddressDetail.postalCode : '',
            phone: (this.paymentComponentSettings.shippingAddressDetail && this.paymentComponentSettings.shippingAddressDetail.phone) ? this.paymentComponentSettings.shippingAddressDetail.phone : '',
        }
        return ShippingAddress;
    }
    ngOnDestroy(): void {
        window.removeEventListener('message', this.iFrameEventFallBackLogic, false);

    }

}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/payments/nexio.component.ts